import axios from "../config/axios-kb"


export const KnowledgeRepository = {
  getSelectors: (organization_id, url) => {
    return axios.get(`/api/knowledge/selectors`, {
      params: {
        organization_id,
        url
      }
    });
  },
  getAll: () => {
    return axios.get(`/api/knowledge`);
  },
  getById: (id) => {
    return axios.get(`/api/knowledge/${id}`);
  },
  filterKnowledge: ({organization_id, topic_id = null, slot_id = null, query = null, page = 1, size = 10, ...props}) => {
    return axios.get(`/api/knowledge/filter`, {
      params: {
        ...props,
        organization_id,
        topic_id,
        slot_id,
        query,
        page,
        size
      }
    });
  },
  delete: (id) => {
    return axios.delete(`/api/knowledge/${id}`)
  },
  create: (formData, setUploadProgress) => {
    return axios.post('/api/knowledge', formData)
  },
  createPdf: (formData, setUploadProgress) => {
    return axios.post('/api/knowledge/pdf',
      formData,
      {
        headers: {"Content-Type": "multipart/form-data"},
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        }
      })
  },
  createTabelar: (formData) => {
    return axios.post('/ai/tabelar', formData)
  },
  edit: (id, formData, setUploadProgress) => {

    return axios.post(`/api/knowledge/${id}/edit`,
      formData,
      {
        headers: {"Content-Type": "multipart/form-data"},
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        }
      })
  },
  updateData: (id, data) => {
    let params = {
      "data": data
    }
    return axios.post(`/api/knowledge/${id}`, params)
  },
  getBySlotId: (slotId) => {
    return axios.get(`/api/knowledge/slot/${slotId}`);
  },
  publish: (id) => {
    return axios.post(`/api/knowledge/${id}/publish`)
  },
  editChunk: (id, uuid, data) => {
    //https://api.kb.openbrain.io/api/knowledge/doc_id/1914/uuid/f4284221-0ab8-45a1-9500-b302b2763737
    return axios.patch(`/api/knowledge/doc_id/${id}/uuid/${uuid}`, data);
  },
  unpublish: (id) => {
    return axios.get(`/api/knowledge/${id}/unpublish`)
  },
  getChunks: (id) => {
    return axios.get(`/api/knowledge/${id}/chunks`)
  },
  republish:(id) => {
    return axios.get(`/api/knowledge/${id}/republish`)
  },
  preview:(id) => {
    return axios.get(`/api/knowledge/${id}`)
  },
  deleteByUUID(knowledgeId, uuid) {
    return axios.delete(`/api/knowledge/doc_id/${knowledgeId}/uuid/${uuid}`)
  },
  getNeo4jNodes: () => {
    return axios.get(`/api/neo4j/nodes`);
  },
  getTopics: () => {
    return axios.get(`https://dev.api.kb.openbrain.io/api/topics`);
  },
}